import useMutation from '@space-shell/common/hooks/useMutation'
import type { DeleteFollowerArgs } from '@space-shell/common/services/communities'
import { CommunitiesService } from '@space-shell/common/services/communities'

export const useDeleteFollower = () => {
  return {
    deleteFollowerQuery: useMutation<void, DeleteFollowerArgs>((payload: DeleteFollowerArgs) =>
      CommunitiesService.deleteFollower(payload)
    )
  }
}
